import { ActionTypes } from './constants';
import * as Models from './models';

export const loadLayoutDetailsMetadata: Models.ActionCreator.LoadLayoutDetailsMetadata = document => ({
  type: ActionTypes.LOAD_LAYOUT_DETAILS_METADATA,
  payload: {
    document,
  },
});

export const updateReusableLayoutTags: Models.ActionCreator.UpdateReusableLayoutTags = (modalWindowId, documentId, tags) => ({
  type: ActionTypes.UPDATE_REUSABLE_LAYOUT_TAGS,
  payload: {
    modalWindowId,
    documentId,
    tags,
  },
});
